import { MageXPatient } from "@prisma/client";

export const mapFieldToLabel: Partial<Record<keyof MageXPatient, string>> = {
  nom: "Nom",
  prenom: "Prénom",
  sexe: "Sexe",
  date_naissance: "Date de naissance",
  num_secu: "Numéro de sécurité sociale",
  poids: "Poids",
  taille: "Taille",
  arret_travail: "Arrêt de travail",
  accident_travail: "Accident de travail",
  statut_social: "Statut social",
  type_profession: "Profession",
  activite_sportive: "Activité sportive",
  intensite_activite_sportive: "Intensité d'activité sportive",
  tabac_actif: "Tabac actif",
  duree_douleur_mois: "Durée de la douleur",
  prise_traitement_anti_coagulant: "Prise de traitement anticoagulant",
  type_traitement_anti_coagulant: "Type de traitement anticoagulant",
  prise_traitement_anti_agregant: "Prise de traitement antiagregant",
  type_traitement_anti_agregant: "Type de traitement antiagregant",
  scores_eva_l: "Scores EVA L",
  scores_eva_r: "Scores EVA R",
  scores_ndi: "Scores NDI",
  scores_oswestry: "Scores Oswestry",
  scores_mfi: "Score mFI-11",
  scores_pomi_5f: "Scores POMI 5F",
  diagnostics_principaux: "Diagnostics principaux",
  antecedents_medical: "Antécédents médicaux",
  antecedents_rachidiens: "Antécédents rachidiens",
  antecedents_chirurgical: "Antécédents chirurgicaux extra-rachidien",
  traitements_non_chirurgicaux: "Traitements rachidiens non chirurgicaux",
  traitements_chirurgical: "Traitements chirurgicaux",
  traitements_chirurgical_niveaux_operes: "Niveaux opérés",
  traitements_chirurgical_lateralite: "Latéralité",
  marques_materiels_osteosyntheses: "Marques de matériels d'ostéosynthèse",
  complication_non_chirurgicale: "Complication non chirurgicale",
  complication_chirurgicale: "Complication chirurgicale",
  traitement_complication: "Traitement de la complication",
  traitement_medical: "Traitement médical",
  surgical_measures_decompression: "Technique de décompression",
  surgical_measures_fusion: "Technique de fusion",
  surgical_measures_fusion_material: "Types de greffes",
  surgical_measures_rigid_stabilisation: "Technique de stabilisation",
  surgical_measures_motion_preserving_stabilisation:
    "Technique de préservation de la mobilité",
  surgical_measures_deformity_correction:
    "Technique de correction de déformation",
  surgical_measures_measures_during_surgery:
    "Gestes réalisés pendant la chirurgie",
  surgical_measures_intraoperative_adverse_events:
    "Complication chirurgicale per-opératoire",
  surgical_measures_intraoperative_general_complications:
    "Complication médicale per-opératoire",
  surgical_measures_implant_labels: "Type d'implants",
  drainage_chirurgical: "Drainage chirurgical",
};
